
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12695',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12695",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9768",
  "foundations-components": "static-1.8139",
  "foundations-components-legacy": "static-1.1164",
  "foundations-theming": "static-1.4536",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8124",
  "hub-http-shared-msw-handlers": "static-1.10218",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11581",
  "I18n": "static-7.1636",
  "jasmine-runner": "static-1.6564",
  "marketplace-storefront-base": "static-1.12758",
  "quartz": "static-1.7162",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16788",
  "reactive-variable-buffer-atom": "static-1.2964",
  "reporting-testing-lib": "static-1.9904",
  "settings-ui-lib": "static-1.12626",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7328",
  "ui-addon-i18n": "static-1.11255",
  "ui-addon-react-router-dom": "static-1.9644",
  "unified-auth": "static-1.618",
  "unified-auth-core-lib": "static-1.900",
  "usage-tracker": "static-1.7455",
  "usage-tracker-core": "static-1.7305",
  "customer-data-property-utils": "static-1.8201",
  "hub-http": "static-1.6329",
  "integrations-lib": "static-1.16491",
  "marketplace-ui-common": "static-1.20125",
  "property-management-iframe": "static-1.13517",
  "quartz-config": "static-1.940",
  "quartz-core": "static-1.6381",
  "quartz-routing": "static-1.592",
  "quick-fetch": "static-1.3994",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4762",
  "ts-schema": "static-1.4157",
  "ui-universal-auth": "static-1.9104",
  "UIComponents": "static-3.8527",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3475",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3439",
  "quartz-webpack": "static-1.3386",
  "bend-plugin-quartz-routing": "static-1.240",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4408",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4979",
  "foundations-theming-specialty": "static-1.2252",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9528",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.34",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5419",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2182",
  "ui-fonts": "static-1.843",
  "ui-images": "static-2.1179",
  "bend-plugin-foundations-theming": "static-1.3019",
  "foundations-theming-base": "static-1.3521",
  "stylex": "static-1.34",
  "HeadJS": "static-2.767",
  "hs-test-utils-bend-plugin": "static-1.3235",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4432",
  "ai-components-ui-library": "static-1.9213",
  "ai-rendering-library": "static-1.10540",
  "chirp-fetch": "static-1.1993",
  "connections-embed-lib": "static-1.1186",
  "copilot-toolkit": "static-1.11401",
  "feedback-loader": "static-1.29491",
  "laboratory-lib": "static-3.7258",
  "marketplace-embed": "static-1.22420",
  "marketplace-ui-details": "static-1.10020",
  "marketplace-ui-reviews": "static-1.20080",
  "marketplace-ui-tracking": "static-1.14295",
  "sanitize-text": "static-1.8251",
  "ui-addon-video-player": "static-1.8809",
  "usage-tracker-multi": "static-1.5869",
  "usage-tracker-session-replay": "static-1.5141",
  "wootric-nps": "static-1.7060",
  "quartz-head": "static-1.827",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4758",
  "immer": "static-1.33",
  "immerable": "static-1.4257",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2564",
  "reporting-data": "static-1.67971",
  "cssUtils": "static-1.822",
  "flux-actions": "static-1.345",
  "HubStyle": "static-2.11888",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10314",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10468",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7445",
  "icons": "static-2.653",
  "marketplace-ui-apps-core": "static-1.18657",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4618",
  "foundations-components-test-utils": "static-1.5622",
  "quartz-i18n": "static-1.837",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.336",
  "google-sheets-integration-lib": "static-1.541",
  "microsoft-drive-integration-lib": "static-1.676",
  "slack-ui-library": "static-1.10501",
  "fsm": "static-1.3835",
  "customer-data-objects": "static-1.7785",
  "property-translator": "static-1.5503",
  "hs-locale-management": "static-1.159",
  "frontend-preferences-client": "static-1.8034",
  "hs-promise-utils": "static-1.5697",
  "hubspot-apollo-client": "static-1.4984",
  "integrations-error-boundary-lib": "static-1.13906",
  "integrations-tracking-lib": "static-1.5712",
  "native-integrations-shared-strings": "static-1.7889",
  "reselect": "static-2.16",
  "sanitize": "static-1.4582",
  "superstore": "static-1.4866",
  "ui-shepherd-react": "static-3.10333",
  "ai-settings-ui-library": "static-1.8053",
  "hub-http-janus": "static-1.843",
  "hubspotter-http": "static-1.4728",
  "immutable-less": "static-1.4759",
  "marketplace-ui-client-types": "static-1.17532",
  "nav-meta": "static-1.29907",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18139",
  "inbound-db-properties-service-client": "static-1.3922",
  "property-management-common": "static-1.5805",
  "ui-addon-iframeable": "static-1.9170",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.542",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.837",
  "quartz-test": "static-1.837",
  "quartz-tracking": "static-1.541",
  "trellis-components": "static-1.2201",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.172",
  "bender-build-tools": "static-1.3281",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21790",
  "ContentUtils": "static-1.68658",
  "customer-data-objects-ui-components": "static-1.13137",
  "sassPrefix": "static-1.158",
  "breeze-engine-core": "static-1.357",
  "breeze-onboarding-components": "static-1.219",
  "avatar-components": "static-1.2604",
  "customer-data-filters-ui": "static-1.40142",
  "customer-data-reference-ui-components": "static-1.13278",
  "embedded-academy-lib": "static-1.14684",
  "ExportDialog": "static-6.10486",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41564",
  "reporting-snowflake": "static-1.56589",
  "reporting-ui-components": "static-2.65242",
  "reporting-visualizations": "static-1.60047",
  "trellis-theming": "static-1.1047",
  "ui-addon-teams": "static-1.21688",
  "integrations-reconnect-lib": "static-1.159",
  "magpie-lib": "static-1.5621",
  "navigation-components": "static-1.18270",
  "breeze-engine-lib": "static-1.1079",
  "magpie-types": "static-1.5081",
  "simple-logging-lib": "static-1.3156",
  "ai-studio-lib": "static-1.11917",
  "app-governance-lib": "static-1.1881",
  "developer-experience-shared-components": "static-1.10620",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8111",
  "ui-product-approvals": "static-1.28571",
  "ui-tool-access": "static-1.10254",
  "usage-based-billing-components-lib": "static-1.9380",
  "usage-tracker-anonymous": "static-1.5872",
  "usage-tracker-public": "static-1.7266",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3663",
  "persist-promise": "static-1.3805",
  "reference-resolvers": "static-1.8280",
  "ui-extensibility-client-types": "static-1.4031",
  "hubspot-apollo-cache": "static-1.443",
  "universal-page-editor-lib": "static-1.3124",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3068",
  "atom": "static-1.5180",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6075",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1648",
  "crm-component-utils": "static-1.39351",
  "crm-properties-common-lib": "static-1.5995",
  "customer-data-properties": "static-1.51932",
  "framework-data-schema-resolvers": "static-1.6998",
  "property-value-citations": "static-1.2546",
  "reference-resolvers-lite": "static-1.8204",
  "ui-business-units-lib": "static-1.9168",
  "navigation-messaging": "static-1.7597",
  "hubspotter-http-shared-msw-handlers": "static-1.10216",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4920",
  "content-icons-ui": "static-1.2256",
  "customer-data-ui-utilities": "static-1.9931",
  "conversations-skeleton-state": "static-1.7354",
  "crm-message-bus": "static-1.43248",
  "customer-data-filters-ui-msw-helpers": "static-1.22577",
  "events-data-lib": "static-1.338",
  "FormUrlGenerator": "static-2.4827",
  "framework-builder-read-service-client": "static-1.4081",
  "framework-data-schema-quick-fetch": "static-1.6903",
  "multi-account-reference-resolvers": "static-1.1088",
  "onboarding-tours": "static-1.16797",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13975",
  "academy-common-lib": "static-1.14144",
  "content-assistance-lib": "static-1.7920",
  "dashboard-lib": "static-1.81933",
  "file-manager-components": "static-1.23905",
  "getting-started-shared-tasks": "static-1.18700",
  "hubspot-prosemirror": "static-1.18518",
  "hubspot-prosemirror-plugins": "static-1.18510",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20013",
  "share-with-third-party-component-lib": "static-1.8811",
  "ui-addon-draggable": "static-3.4866",
  "ui-asset-management-lib": "static-1.11168",
  "user-context": "static-1.5216",
  "growth-payments-core": "static-1.25681",
  "reporting-plugins": "static-1.10495",
  "reporting-reports": "static-1.67649",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.831",
  "nest": "static-1.338",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10733",
  "framework-listing-lib": "static-2.28984",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30959",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4359",
  "react-dnd-compat": "static-1.4721",
  "ui-product-approvals-common": "static-1.466",
  "onboarding-scopes": "static-1.6567",
  "onboarding-tours-client": "static-1.5011",
  "platform-infra-nav-components": "static-1.7749",
  "subscription-experience-data-types": "static-1.15056",
  "crm-record-cards-service-types": "static-1.3666",
  "location-customization-utils-lib": "static-1.9563",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6078",
  "signup-constants": "static-1.19090",
  "signup-ui-url-generator": "static-2.8163",
  "card-properties-lib": "static-1.44503",
  "commerce-subscription-lib": "static-1.37391",
  "crm-actions": "static-1.6445",
  "crm-cards-sdk": "static-1.43886",
  "customer-data-properties-shared-msw-handlers": "static-1.9545",
  "customer-data-tracking": "static-1.6995",
  "hs-resources": "static-1.279",
  "pulse": "static-1.702",
  "calling-global-api": "static-1.64867",
  "calling-internal-common": "static-1.31416",
  "calling-lifecycle-internal": "static-1.66249",
  "calling-lifecycle-messages": "static-1.58543",
  "commerce-products-lib": "static-1.9934",
  "conditional-properties-service-client": "static-1.3873",
  "crm-links": "static-1.6414",
  "crm-pipelines-api-client-types": "static-1.4215",
  "external-options-client-types": "static-1.4206",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4294",
  "meetings-icalendar-utils-lib": "static-1.740",
  "multi-currency-client-types": "static-1.3767",
  "object-builder-ui-client": "static-1.49100",
  "pipeline-validation-client-types": "static-1.4043",
  "smart-property-lib": "static-1.7743",
  "tiered-pricing": "static-1.1483",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11095",
  "fdsr-migration-layer": "static-1.117",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1139",
  "growth-data-modal": "static-1.5595",
  "growth-onboarding-confetti": "static-1.3171",
  "growth-onboarding-next-action-utils": "static-1.2221",
  "onboarding-tours-utils": "static-1.863",
  "ui-shepherd-tracker": "static-1.7714",
  "academy-service-client": "static-1.3790",
  "SafeStorage": "static-1.4505",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39404",
  "FileManagerLib": "static-1.39545",
  "video-embed": "static-1.36106",
  "ui-coaching-tips": "static-1.28848",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11614",
  "video-data-lib": "static-1.35272",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23796",
  "ui-addon-emoji-picker": "static-1.9993",
  "EmailSignatureEditor": "static-1.24601",
  "viral-links-lib": "static-1.7175",
  "data-token-picker": "static-1.16592",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.329",
  "timezone-utils": "static-2.5349",
  "seat-types-lib": "static-1.253",
  "getting-started-shared-tasks-store": "static-1.17818",
  "ui-addon-opt": "static-4.8467",
  "campaign-roi-lib": "static-1.9394",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25661",
  "framework-data-table": "static-2.12152",
  "marketing-platform-lib": "static-1.6972",
  "nudge-client-utils": "static-1.2800",
  "nudge-custom-ui-functions": "static-1.1212",
  "switchboard-lib": "static-1.330",
  "app-users-service-client": "static-1.5714",
  "app-users-service-types": "static-1.5122",
  "mini-checkout-client": "static-1.27067",
  "onboarding-utils": "static-1.5465",
  "permissions-shared-i18n-strings-fe": "static-1.2061",
  "ui-coaching-tips-shared-config": "static-1.28833",
  "edison-service-client-types": "static-1.495",
  "crm_data": "static-4.92283",
  "customer-data-sidebar": "static-2.46299",
  "enrichment-properties-lib": "static-1.16861",
  "ui-addon-draggable-compat": "static-2.4365",
  "universal-record-utils-lib": "static-1.1207",
  "commerce-billing-lib": "static-1.19416",
  "commerce-shared-components-lib": "static-1.18782",
  "commerce-tools-ui-lib": "static-1.10654",
  "crm-fe-perf": "static-1.23010",
  "event-emitter": "static-1.1056",
  "bend-plugin-pulse": "static-1.205",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31423",
  "shared-worker-versioning": "static-1.11141",
  "calling-usage-tracker": "static-1.6649",
  "voice-sms-access-library": "static-1.1403",
  "commerce-permissions": "static-1.883",
  "products-iframe-lib": "static-1.8221",
  "products-ui-components-shared-msw-handlers": "static-1.10600",
  "data-agent-kit": "static-1.365",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10301",
  "policy-lib": "static-1.6888",
  "react-tinymce": "static-1.55516",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10364",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54642",
  "tinymce-plugins": "static-1.57756",
  "tinymce-themes": "static-1.56612",
  "onboarding-data-sync-lib": "static-1.2140",
  "growth-onboarding-next-action-components": "static-1.2249",
  "user-context-client": "static-1.4687",
  "audio-components": "static-1.6077",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37056",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4642",
  "video-components": "static-1.13616",
  "outpost": "static-1.4276",
  "growth-onboarding-feedback-components": "static-1.6685",
  "content-media-composition-data-lib": "static-1.12640",
  "content-media-compositions": "static-2.16647",
  "media-bridge-lib": "static-1.19108",
  "commerce-tours-lib": "static-1.6291",
  "growth-onboarding-reliability": "static-1.5187",
  "sales-checkout-service-client": "static-1.3699",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21860",
  "sales-email-signature-service-client": "static-1.3955",
  "ts-utils-lib": "static-1.278",
  "crm-export-dialog": "static-1.6391",
  "crm-index-associations-lib": "static-1.6547",
  "crm-view-components": "static-1.589",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7436",
  "nudge-custom-function-registry": "static-1.2557",
  "nudge-renderer-utils": "static-1.2876",
  "whisper-core-api": "static-1.6848",
  "InboxConnectUtils": "static-4.15083",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5778",
  "settings-content-modals": "static-1.46374",
  "crm_universal": "static-1.22192",
  "customer-data-email": "static-1.18221",
  "card-payment-highlight-lib": "static-1.37464",
  "card-subscription-highlight-lib": "static-1.39814",
  "commerce-contract-lib": "static-1.12568",
  "invoices-highlight-card-lib": "static-1.55063",
  "orders-highlight-card-lib": "static-1.21751",
  "products-highlight-card-lib": "static-1.18217",
  "quotes-highlight-card-lib": "static-1.72360",
  "crm-source-interpretation-lib": "static-1.5449",
  "crm-object-search-query-utilities": "static-1.9814",
  "utility-belt": "static-1.2639",
  "payments-enrollment-embed-lib": "static-1.23217",
  "stripe-embedded-components": "static-1.7694",
  "customer-data-rte": "static-1.33267",
  "cv-backend-services": "static-1.1558",
  "growth-onboarding-empty-states": "static-1.5933",
  "payments-post-enroll-local-storage-lib": "static-1.5212",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38450",
  "trials-service-types": "static-1.3988",
  "calling-orchestration-schema": "static-1.36180",
  "sales-views-client-types": "static-1.4362",
  "hub-http-contrib": "static-1.3149",
  "interframe": "static-3.4866",
  "tinymce-data": "static-1.40727",
  "ui-addon-sales-email": "static-1.5316",
  "layout-dnd-components": "static-1.12646",
  "layout-dnd-utils": "static-1.11621",
  "ui-brand-identity-lib": "static-1.15648",
  "NamespacedHubStyle": "static-2.9133",
  "meetings-connect-utils-lib": "static-1.7710",
  "social-insights-client-types": "static-1.22323",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4273",
  "checkout-sdk": "static-3.23910",
  "checkout-service-types": "static-1.3874",
  "company-details-components": "static-1.6303",
  "payment-method-components": "static-1.6979",
  "pricing-pages-ui-components": "static-1.14660",
  "quote-checkout-service-types": "static-1.3570",
  "upgrade-catalog-service-types": "static-1.3628",
  "access-control-lib": "static-1.10540",
  "EmailComponents": "static-1.55053",
  "EmailData": "static-1.53730",
  "redux-less": "static-2.9588",
  "sequences-lib": "static-1.8230",
  "ui-gdpr-components": "static-1.10457",
  "products-ui-components": "static-1.40452",
  "accounting-integrations-ui-components": "static-1.7235",
  "invoices-ui-lib": "static-1.55079",
  "commerce-products-api": "static-1.2446",
  "invoices-iframe-lib": "static-1.57137",
  "quotes-modal-lib": "static-1.103038",
  "quotes-ui-lib": "static-1.81081",
  "stripe-connect-js": "static-1.70",
  "draft-content-plugins": "static-1.28536",
  "ContentData": "static-1.68733",
  "layout-data-lib": "static-1.9946",
  "hub-http-rxjs": "static-1.808",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4043",
  "billing-payments-client-types": "static-1.4097",
  "react-performance-metrics-lib": "static-1.662",
  "account-and-billing-fintech-outages": "static-3.18710",
  "pricing-pages-api": "static-1.14525",
  "ContentComponents": "static-2.71614",
  "marketing-contacts-lib": "static-1.10390",
  "marketing-email-service-types": "static-1.1982",
  "messaging-editing-lib": "static-1.46563",
  "messaging-usage-based-billing-components-lib": "static-1.1425",
  "automation-ui-source-apps": "static-1.19181",
  "automation-ui-types": "static-1.20099",
  "messaging-types-lib": "static-1.46300",
  "onboarding-settings-client": "static-1.4608",
  "sequences-client-types-lib": "static-1.8087",
  "commerce-tax-lib": "static-1.642",
  "price-books-api": "static-1.1205",
  "price-books-components": "static-1.1263",
  "property-description-translator": "static-1.3947",
  "ramp-editor": "static-1.417",
  "commerce-analytics-service-client": "static-1.3687",
  "totals-ui-components": "static-1.23879",
  "SalesContentIndexUI": "static-3.9393",
  "advanced-menus-core": "static-1.15297",
  "advanced-menus-lib": "static-1.12211",
  "ui-memberships-settings-lib": "static-1.34324",
  "segments-query-core": "static-1.1526",
  "automation-ui-ubb": "static-1.6015",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7444",
  "data-token-views": "static-1.16573",
  "forms-utils-lib": "static-1.12779",
  "payments-embed-points-lib": "static-1.13249",
  "simple-menus-core": "static-1.15296",
  "simple-menus-lib": "static-1.16813",
  "videoconference-integration-components": "static-1.6969",
  "marketing-contacts-client": "static-1.7619",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2629",
  "ContentEditorUI": "static-2.77399",
  "short-messages-app-service-client": "static-1.4030",
  "web-interactives-components": "static-1.13944",
  "web-interactives-data": "static-1.13945",
  "messaging-shared-utils-lib": "static-1.874",
  "messaging-user-info-utils-lib": "static-1.1044",
  "email-portal-health-service-types": "static-1.1082",
  "line-items-api": "static-1.848",
  "commerce-totals-service-types": "static-1.3895",
  "FireAlarmUi": "static-1.4585",
  "sales-templates-service-types-lib": "static-1.4246",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22035",
  "automation-ui-usage-tracking": "static-1.21498",
  "data-studio-ubb": "static-1.3019",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27256",
  "collaboration-sidebar": "static-1.58147",
  "content-management-data-lib": "static-1.5581",
  "copilot-plugins": "static-1.11374",
  "cta-picker": "static-1.36673",
  "customer-agent-discovery-components-lib": "static-1.3383",
  "editor-components": "static-1.13379",
  "editor-iframe-lib": "static-1.8546",
  "error-messaging-js": "static-1.5297",
  "FormsCommonComponents": "static-1.86111",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10752",
  "SharedLegalStrings": "static-1.1852",
  "smart-content-core": "static-1.42720",
  "smart-content-lib": "static-1.43373",
  "social-composer-lib": "static-1.59528",
  "structured-content-lib": "static-1.25464",
  "theme-previewer-lib": "static-1.53524",
  "tinymce-copilot": "static-1.16710",
  "xray-recommendation-lib": "static-1.8043",
  "automation-ui-routing": "static-1.21456",
  "sql-reporting-client-types": "static-1.5722",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42417",
  "campaigns-utils-lib": "static-1.3295",
  "reporting-enablement": "static-1.23280",
  "chatspot-widget-iframe": "static-1.21781",
  "collaboration-sidebar-common": "static-1.2944",
  "forms-ai-lib": "static-1.4483",
  "codemirror-dlb": "static-1.58958",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6542",
  "report-customization-components": "static-1.13452",
  "data-quality-ui-library": "static-1.13303",
  "reporting-filters": "static-1.579",
  "reporting-insights-lib": "static-1.2044"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12695",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9768",
  "foundations-components": "/foundations-components/static-1.8139",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1164",
  "foundations-theming": "/foundations-theming/static-1.4536",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8124",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10218",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11581",
  "I18n": "/I18n/static-7.1636",
  "jasmine-runner": "/jasmine-runner/static-1.6564",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12758",
  "quartz": "/quartz/static-1.7162",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16788",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2964",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9904",
  "settings-ui-lib": "/settings-ui-lib/static-1.12626",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7328",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11255",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9644",
  "unified-auth": "/unified-auth/static-1.618",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.900",
  "usage-tracker": "/usage-tracker/static-1.7455",
  "usage-tracker-core": "/usage-tracker-core/static-1.7305",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8201",
  "hub-http": "/hub-http/static-1.6329",
  "integrations-lib": "/integrations-lib/static-1.16491",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20125",
  "property-management-iframe": "/property-management-iframe/static-1.13517",
  "quartz-config": "/quartz-config/static-1.940",
  "quartz-core": "/quartz-core/static-1.6381",
  "quartz-routing": "/quartz-routing/static-1.592",
  "quick-fetch": "/quick-fetch/static-1.3994",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4762",
  "ts-schema": "/ts-schema/static-1.4157",
  "ui-universal-auth": "/ui-universal-auth/static-1.9104",
  "UIComponents": "/UIComponents/static-3.8527",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3475",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3439",
  "quartz-webpack": "/quartz-webpack/static-1.3386",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.240",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4408",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4979",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2252",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9528",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.34",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5419",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2182",
  "ui-fonts": "/ui-fonts/static-1.843",
  "ui-images": "/ui-images/static-2.1179",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3019",
  "foundations-theming-base": "/foundations-theming-base/static-1.3521",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.767",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3235",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4432",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9213",
  "ai-rendering-library": "/ai-rendering-library/static-1.10540",
  "chirp-fetch": "/chirp-fetch/static-1.1993",
  "connections-embed-lib": "/connections-embed-lib/static-1.1186",
  "copilot-toolkit": "/copilot-toolkit/static-1.11401",
  "feedback-loader": "/feedback-loader/static-1.29491",
  "laboratory-lib": "/laboratory-lib/static-3.7258",
  "marketplace-embed": "/marketplace-embed/static-1.22420",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10020",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20080",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14295",
  "sanitize-text": "/sanitize-text/static-1.8251",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8809",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5869",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5141",
  "wootric-nps": "/wootric-nps/static-1.7060",
  "quartz-head": "/quartz-head/static-1.827",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4758",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4257",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "reporting-data": "/reporting-data/static-1.67971",
  "cssUtils": "/cssUtils/static-1.822",
  "flux-actions": "/flux-actions/static-1.345",
  "HubStyle": "/HubStyle/static-2.11888",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10314",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10468",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7445",
  "icons": "/icons/static-2.653",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18657",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4618",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5622",
  "quartz-i18n": "/quartz-i18n/static-1.837",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.336",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.541",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.676",
  "slack-ui-library": "/slack-ui-library/static-1.10501",
  "fsm": "/fsm/static-1.3835",
  "customer-data-objects": "/customer-data-objects/static-1.7785",
  "property-translator": "/property-translator/static-1.5503",
  "hs-locale-management": "/hs-locale-management/static-1.159",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8034",
  "hs-promise-utils": "/hs-promise-utils/static-1.5697",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4984",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13906",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5712",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7889",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4582",
  "superstore": "/superstore/static-1.4866",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10333",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8053",
  "hub-http-janus": "/hub-http-janus/static-1.843",
  "hubspotter-http": "/hubspotter-http/static-1.4728",
  "immutable-less": "/immutable-less/static-1.4759",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17532",
  "nav-meta": "/nav-meta/static-1.29907",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18139",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3922",
  "property-management-common": "/property-management-common/static-1.5805",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9170",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.542",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.837",
  "quartz-test": "/quartz-test/static-1.837",
  "quartz-tracking": "/quartz-tracking/static-1.541",
  "trellis-components": "/trellis-components/static-1.2201",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.172",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21790",
  "ContentUtils": "/ContentUtils/static-1.68658",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13137",
  "sassPrefix": "/sassPrefix/static-1.158",
  "breeze-engine-core": "/breeze-engine-core/static-1.357",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.219",
  "avatar-components": "/avatar-components/static-1.2604",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40142",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13278",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14684",
  "ExportDialog": "/ExportDialog/static-6.10486",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41564",
  "reporting-snowflake": "/reporting-snowflake/static-1.56589",
  "reporting-ui-components": "/reporting-ui-components/static-2.65242",
  "reporting-visualizations": "/reporting-visualizations/static-1.60047",
  "trellis-theming": "/trellis-theming/static-1.1047",
  "ui-addon-teams": "/ui-addon-teams/static-1.21688",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.159",
  "magpie-lib": "/magpie-lib/static-1.5621",
  "navigation-components": "/navigation-components/static-1.18270",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1079",
  "magpie-types": "/magpie-types/static-1.5081",
  "simple-logging-lib": "/simple-logging-lib/static-1.3156",
  "ai-studio-lib": "/ai-studio-lib/static-1.11917",
  "app-governance-lib": "/app-governance-lib/static-1.1881",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10620",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8111",
  "ui-product-approvals": "/ui-product-approvals/static-1.28571",
  "ui-tool-access": "/ui-tool-access/static-1.10254",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9380",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5872",
  "usage-tracker-public": "/usage-tracker-public/static-1.7266",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3663",
  "persist-promise": "/persist-promise/static-1.3805",
  "reference-resolvers": "/reference-resolvers/static-1.8280",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4031",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.443",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3124",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3068",
  "atom": "/atom/static-1.5180",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6075",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1648",
  "crm-component-utils": "/crm-component-utils/static-1.39351",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5995",
  "customer-data-properties": "/customer-data-properties/static-1.51932",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6998",
  "property-value-citations": "/property-value-citations/static-1.2546",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8204",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9168",
  "navigation-messaging": "/navigation-messaging/static-1.7597",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10216",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4920",
  "content-icons-ui": "/content-icons-ui/static-1.2256",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9931",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7354",
  "crm-message-bus": "/crm-message-bus/static-1.43248",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22577",
  "events-data-lib": "/events-data-lib/static-1.338",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4827",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4081",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6903",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1088",
  "onboarding-tours": "/onboarding-tours/static-1.16797",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13975",
  "academy-common-lib": "/academy-common-lib/static-1.14144",
  "content-assistance-lib": "/content-assistance-lib/static-1.7920",
  "dashboard-lib": "/dashboard-lib/static-1.81933",
  "file-manager-components": "/file-manager-components/static-1.23905",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18700",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18518",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18510",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20013",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8811",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4866",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11168",
  "user-context": "/user-context/static-1.5216",
  "growth-payments-core": "/growth-payments-core/static-1.25681",
  "reporting-plugins": "/reporting-plugins/static-1.10495",
  "reporting-reports": "/reporting-reports/static-1.67649",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.831",
  "nest": "/nest/static-1.338",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10733",
  "framework-listing-lib": "/framework-listing-lib/static-2.28984",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30959",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4359",
  "react-dnd-compat": "/react-dnd-compat/static-1.4721",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.466",
  "onboarding-scopes": "/onboarding-scopes/static-1.6567",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5011",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7749",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15056",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3666",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9563",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6078",
  "signup-constants": "/signup-constants/static-1.19090",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8163",
  "card-properties-lib": "/card-properties-lib/static-1.44503",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37391",
  "crm-actions": "/crm-actions/static-1.6445",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43886",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9545",
  "customer-data-tracking": "/customer-data-tracking/static-1.6995",
  "hs-resources": "/hs-resources/static-1.279",
  "pulse": "/pulse/static-1.702",
  "calling-global-api": "/calling-global-api/static-1.64867",
  "calling-internal-common": "/calling-internal-common/static-1.31416",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66249",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58543",
  "commerce-products-lib": "/commerce-products-lib/static-1.9934",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3873",
  "crm-links": "/crm-links/static-1.6414",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4215",
  "external-options-client-types": "/external-options-client-types/static-1.4206",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4294",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.740",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3767",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49100",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4043",
  "smart-property-lib": "/smart-property-lib/static-1.7743",
  "tiered-pricing": "/tiered-pricing/static-1.1483",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11095",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.117",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1139",
  "growth-data-modal": "/growth-data-modal/static-1.5595",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3171",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2221",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.863",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7714",
  "academy-service-client": "/academy-service-client/static-1.3790",
  "SafeStorage": "/SafeStorage/static-1.4505",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39404",
  "FileManagerLib": "/FileManagerLib/static-1.39545",
  "video-embed": "/video-embed/static-1.36106",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28848",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11614",
  "video-data-lib": "/video-data-lib/static-1.35272",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23796",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9993",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24601",
  "viral-links-lib": "/viral-links-lib/static-1.7175",
  "data-token-picker": "/data-token-picker/static-1.16592",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.329",
  "timezone-utils": "/timezone-utils/static-2.5349",
  "seat-types-lib": "/seat-types-lib/static-1.253",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17818",
  "ui-addon-opt": "/ui-addon-opt/static-4.8467",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9394",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25661",
  "framework-data-table": "/framework-data-table/static-2.12152",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6972",
  "nudge-client-utils": "/nudge-client-utils/static-1.2800",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1212",
  "switchboard-lib": "/switchboard-lib/static-1.330",
  "app-users-service-client": "/app-users-service-client/static-1.5714",
  "app-users-service-types": "/app-users-service-types/static-1.5122",
  "mini-checkout-client": "/mini-checkout-client/static-1.27067",
  "onboarding-utils": "/onboarding-utils/static-1.5465",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2061",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28833",
  "edison-service-client-types": "/edison-service-client-types/static-1.495",
  "crm_data": "/crm_data/static-4.92283",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46299",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16861",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4365",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1207",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19416",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18782",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10654",
  "crm-fe-perf": "/crm-fe-perf/static-1.23010",
  "event-emitter": "/event-emitter/static-1.1056",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.205",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31423",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11141",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6649",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1403",
  "commerce-permissions": "/commerce-permissions/static-1.883",
  "products-iframe-lib": "/products-iframe-lib/static-1.8221",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10600",
  "data-agent-kit": "/data-agent-kit/static-1.365",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10301",
  "policy-lib": "/policy-lib/static-1.6888",
  "react-tinymce": "/react-tinymce/static-1.55516",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10364",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54642",
  "tinymce-plugins": "/tinymce-plugins/static-1.57756",
  "tinymce-themes": "/tinymce-themes/static-1.56612",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2140",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2249",
  "user-context-client": "/user-context-client/static-1.4687",
  "audio-components": "/audio-components/static-1.6077",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37056",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4642",
  "video-components": "/video-components/static-1.13616",
  "outpost": "/outpost/static-1.4276",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6685",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12640",
  "content-media-compositions": "/content-media-compositions/static-2.16647",
  "media-bridge-lib": "/media-bridge-lib/static-1.19108",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6291",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5187",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3699",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21860",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3955",
  "ts-utils-lib": "/ts-utils-lib/static-1.278",
  "crm-export-dialog": "/crm-export-dialog/static-1.6391",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6547",
  "crm-view-components": "/crm-view-components/static-1.589",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7436",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2557",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2876",
  "whisper-core-api": "/whisper-core-api/static-1.6848",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15083",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5778",
  "settings-content-modals": "/settings-content-modals/static-1.46374",
  "crm_universal": "/crm_universal/static-1.22192",
  "customer-data-email": "/customer-data-email/static-1.18221",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37464",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39814",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12568",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55063",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21751",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18217",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72360",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5449",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9814",
  "utility-belt": "/utility-belt/static-1.2639",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23217",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7694",
  "customer-data-rte": "/customer-data-rte/static-1.33267",
  "cv-backend-services": "/cv-backend-services/static-1.1558",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5933",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5212",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38450",
  "trials-service-types": "/trials-service-types/static-1.3988",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36180",
  "sales-views-client-types": "/sales-views-client-types/static-1.4362",
  "hub-http-contrib": "/hub-http-contrib/static-1.3149",
  "interframe": "/interframe/static-3.4866",
  "tinymce-data": "/tinymce-data/static-1.40727",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5316",
  "layout-dnd-components": "/layout-dnd-components/static-1.12646",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11621",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15648",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9133",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7710",
  "social-insights-client-types": "/social-insights-client-types/static-1.22323",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4273",
  "checkout-sdk": "/checkout-sdk/static-3.23910",
  "checkout-service-types": "/checkout-service-types/static-1.3874",
  "company-details-components": "/company-details-components/static-1.6303",
  "payment-method-components": "/payment-method-components/static-1.6979",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14660",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3570",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3628",
  "access-control-lib": "/access-control-lib/static-1.10540",
  "EmailComponents": "/EmailComponents/static-1.55053",
  "EmailData": "/EmailData/static-1.53730",
  "redux-less": "/redux-less/static-2.9588",
  "sequences-lib": "/sequences-lib/static-1.8230",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10457",
  "products-ui-components": "/products-ui-components/static-1.40452",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7235",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55079",
  "commerce-products-api": "/commerce-products-api/static-1.2446",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57137",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103038",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81081",
  "stripe-connect-js": "/stripe-connect-js/static-1.70",
  "draft-content-plugins": "/draft-content-plugins/static-1.28536",
  "ContentData": "/ContentData/static-1.68733",
  "layout-data-lib": "/layout-data-lib/static-1.9946",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.808",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4043",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4097",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.662",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18710",
  "pricing-pages-api": "/pricing-pages-api/static-1.14525",
  "ContentComponents": "/ContentComponents/static-2.71614",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10390",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1982",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46563",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1425",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19181",
  "automation-ui-types": "/automation-ui-types/static-1.20099",
  "messaging-types-lib": "/messaging-types-lib/static-1.46300",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4608",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8087",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.642",
  "price-books-api": "/price-books-api/static-1.1205",
  "price-books-components": "/price-books-components/static-1.1263",
  "property-description-translator": "/property-description-translator/static-1.3947",
  "ramp-editor": "/ramp-editor/static-1.417",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3687",
  "totals-ui-components": "/totals-ui-components/static-1.23879",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9393",
  "advanced-menus-core": "/advanced-menus-core/static-1.15297",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12211",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34324",
  "segments-query-core": "/segments-query-core/static-1.1526",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6015",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7444",
  "data-token-views": "/data-token-views/static-1.16573",
  "forms-utils-lib": "/forms-utils-lib/static-1.12779",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13249",
  "simple-menus-core": "/simple-menus-core/static-1.15296",
  "simple-menus-lib": "/simple-menus-lib/static-1.16813",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6969",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7619",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2629",
  "ContentEditorUI": "/ContentEditorUI/static-2.77399",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4030",
  "web-interactives-components": "/web-interactives-components/static-1.13944",
  "web-interactives-data": "/web-interactives-data/static-1.13945",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.874",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1044",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1082",
  "line-items-api": "/line-items-api/static-1.848",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3895",
  "FireAlarmUi": "/FireAlarmUi/static-1.4585",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4246",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22035",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21498",
  "data-studio-ubb": "/data-studio-ubb/static-1.3019",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27256",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58147",
  "content-management-data-lib": "/content-management-data-lib/static-1.5581",
  "copilot-plugins": "/copilot-plugins/static-1.11374",
  "cta-picker": "/cta-picker/static-1.36673",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3383",
  "editor-components": "/editor-components/static-1.13379",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8546",
  "error-messaging-js": "/error-messaging-js/static-1.5297",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86111",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10752",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1852",
  "smart-content-core": "/smart-content-core/static-1.42720",
  "smart-content-lib": "/smart-content-lib/static-1.43373",
  "social-composer-lib": "/social-composer-lib/static-1.59528",
  "structured-content-lib": "/structured-content-lib/static-1.25464",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53524",
  "tinymce-copilot": "/tinymce-copilot/static-1.16710",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8043",
  "automation-ui-routing": "/automation-ui-routing/static-1.21456",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5722",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42417",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3295",
  "reporting-enablement": "/reporting-enablement/static-1.23280",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21781",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2944",
  "forms-ai-lib": "/forms-ai-lib/static-1.4483",
  "codemirror-dlb": "/codemirror-dlb/static-1.58958",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6542",
  "report-customization-components": "/report-customization-components/static-1.13452",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13303",
  "reporting-filters": "/reporting-filters/static-1.579",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2044"
}
};
